// Function to inject pdp-custom-badge into pmslider-slide--inner elements
function injectProductBadges() {
  // Get the original badges element to clone
  const originalBadges = document.querySelector(".pdp-custom-badge");

  if (!originalBadges) {
    console.error("Could not find the .pdp-custom-badge element");
    return;
  }

  // Get all slide inner elements
  const slideInners = document.querySelectorAll(".pmslider-slide--inner");

  if (slideInners.length === 0) {
    console.error("Could not find any .pmslider-slide--inner elements");
    return;
  }

  // Clone and inject badges into each slide inner
  slideInners.forEach((slideInner) => {
    // Check if badges are already injected
    if (slideInner.querySelector(".pdp-custom-badge")) {
      return;
    }

    // Clone the badges element
    const badgesClone = originalBadges.cloneNode(true);

    // Append the clone to the slide inner
    slideInner.appendChild(badgesClone);
  });
}

// Function to watch for DOM changes and inject badges when slides are available
function watchForSlides() {
  // Create a MutationObserver to watch for DOM changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check if new nodes were added
      if (mutation.addedNodes.length) {
        // Check if .pmslider-slide--inner elements exist now
        const slideInners = document.querySelectorAll(".pmslider-slide--inner");
        if (slideInners.length > 0) {
          injectProductBadges();
        }
      }
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  // Also try to inject immediately in case elements are already in the DOM
  injectProductBadges();
}

// Start watching for slides when the document is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", watchForSlides);
} else {
  watchForSlides();
}
